import React from "react";
import { useNavigate } from "react-router-dom";

function PagePreview({ page }) {
  const navigate = useNavigate();

  const handleViewPage = () => {
    window.open(`/${page.link}`, "_blank", "noopener,noreferrer");
  };

  const handleEditPage = () => {
    navigate(`/admin/${page.link}`);
  };

  return (
    <div className="card mb-3" style={{ height: "500px", border: "1px solid #ccc" }}>
      <iframe
        src={`/${page.link}` || "about:blank"}
        style={{
          width: "100%",
          height: "80%",
          border: "none",
          backgroundColor: page.content ? "transparent" : "#fff",
        }}
        title={`Preview Seite ${page.link}`}
      ></iframe>
      <div className="card-footer d-flex justify-content-between">
        <button className="btn btn-primary" onClick={handleViewPage}>
          Anzeigen
        </button>
        <button className="btn btn-secondary" onClick={handleEditPage}>
          Bearbeiten
        </button>
      </div>
    </div>
  );
}

export default PagePreview;
